export default __webpack_public_path__ + "static/media/campaigns_blue_gradient.dbe7a7c1.svg";